<template>
  <div class="popup" v-cloak v-if="deleteSelectedTaskShow">
    <div class="content" id="deleteTask">
      <div class="title">
        {{$t('language.popup.taskListPopup.deleteTask')}}
        <div class="icon white-close dialog-close" @click="deleteSelectedTaskShow=false"></div>
      </div>
      <div class="delete-body">
        <div class="delete-info">
          <div v-if="selectedItems.length">{{$t('language.popup.taskListPopup.sureDeleteTask')}}</div>
          <div v-if="!selectedItems.length">{{$t('language.popup.taskListPopup.pleaseSelect')}}</div>
        </div>
        <div class="delete-task-button" v-if="selectedItems.length">
          <button @click="deleteSelectedTask()">{{$t('language.common.delete')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import commonUtils from "@/js/workspace/common_util.js";
  import taskListUtils from "@/js/workspace/task_list_util.js";
  export default {
    data() {
      return {
        deleteSelectedTaskShow: false,
        selectedItems: '',
      }
    },
    methods: {
      deleteSelectedTask() { //删除选中的任务项
        let that = this;
        that.$parent.eidtTaskFlag = false;
        that.deleteSelectedTaskShow = false;
        that.$parent.deleteloading = true;
        that.$parent.collapseFlage = -1;
        $.each(this.selectedItems, function(i, selectItem) {
          let deleteData = that.deleteInfo(selectItem);
          if (selectItem.branchType != 'realtime') {
            if (selectItem.type == 6) { //如果想删除任务的类型是备份任务
              if (selectItem.status == 'Restoring' || selectItem.status == 'Running' || selectItem.status ==
                'Waiting') {
                var cancelData;
                if (selectItem.groupId) {
                  cancelData = new taskListUtils.cancelGdData(commonUtils.getUser().id, selectItem.type, selectItem
                    .groupId, selectItem.id);
                } else {
                  cancelData = new taskListUtils.cancelIdData(commonUtils.getUser().id, selectItem.type, selectItem
                    .id, selectItem.id);
                }
                that.Utils.doTasksRequest('cancel', cancelData).then(res => {
                  if (res.status == 200 || res.reason == 'notFoundTask') {
                    that.Utils.doTasksRequest("delete", deleteData).then(res => { //删除任务
                      if (res.status == 200) {
                        that.deleteTaskRespone(selectItem, i);
                      } else {
                        that.$parent.deleteloading = false;
                        that.$toast({
                          text: that.$t('language.exception.' + res.reason),
                          type: 'fail',
                          idValue: "rightBodyList"
                        });
                      }
                    }, err => {
                      that.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "rightBodyList"
                      });
                    });
                  }
                });
                return;
              }
            }
            if (selectItem.branchType == 'businessTransfer') {
              deleteData = {
                id: selectItem.id,
                ud: commonUtils.getUser().id
              }
              that.Utils.doBusinessTransferRequest("delete", deleteData).then(res => {
                that.deleteTaskRespone(selectItem, i);
              }).catch(err => {
                that.$parent.deleteloading = false;
                if (err.reason) {
                  err = that.$t('language.exception.' + err.reason)
                }
                that.$toast({
                  text: err,
                  type: 'fail',
                  idValue: "rightBodyList"
                });
              });
              return;
            }
            that.Utils.doTasksRequest("delete", deleteData).then(res => { //删除任务
              if (res.status == 200) {
                that.deleteTaskRespone(selectItem, i);
              } else {
                that.$parent.deleteloading = false;
                that.$toast({
                  text: that.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "rightBodyList"
                });
              }
            }, err => {
              that.$toast({
                text: err,
                type: 'fail',
                idValue: "rightBodyList"
              });
            });
          } else {
            that.Utils.doRealtimeSyncRequest('cancel', deleteData).then(res => { //删除任务
              if (res.message == 'success') {
                that.deleteTaskRespone(selectItem, i);
              } else {
                that.$parent.deleteloading = false;
                that.$toast({
                  text: that.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "rightBodyList"
                });
              }
            }, err => {
              that.$toast({
                text: err,
                type: 'fail',
                idValue: "rightBodyList"
              });
            });
          }
        });
      },
      deleteInfo(selectItem) { //封装删除信息
        let taskType;
        let deleteData;
        if (selectItem.groupId) {
          deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, null, selectItem
            .groupId);
        } else {
          deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, selectItem.id, null);
        }
        return deleteData;
      },
      //删除数据成功后的操作
      deleteTaskRespone(selectItem, i) {
        let that = this;
        let allGroupArr = Object.assign([], that.$store.state.taskListNotGropArr);
        if (selectItem.groupId) { //返回未删除的数据
          that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
            return item.groupId != selectItem.groupId;
          });
        } else {
          that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
            return item.id != selectItem.id;
          });
        }
        if (!that.$store.state.taskListNotGropArr.length) { //如果清空了任务数据，设置任务列表为空
          that.$store.commit('setTaskListArrAll', []);
        }
        if (i == that.selectedItems.length - 1) { //如果数据删除完毕，清空选中数据，清空加载效果
          that.$parent.selectedArr = [];
          that.$parent.deleteloading = false;
        }

      }

    }

  }
</script>

<style>
  #deleteTask {
    width: 500px;
    /*no*/
    height: 180px;
    /*no*/
  }

  .delete-body {
    width: 100%;
    /*no*/
    height: 140px;
    /*no*/
    color: #6f7886;
    padding-left: 20px;
    /*no*/
    box-sizing: border-box;
  }

  .delete-info {
    width: 100%;
    position: relative;
    top: 40px;
    /*no*/
    float: left;
  }

  .delete-task-button {
    float: right;
    top: 70px;
    /*no*/
    right: 20px;
    /*no*/
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/delete_selected_tasks_popups.vue